// extracted by mini-css-extract-plugin
export default {"MobileHeader":"MobileHeader_MobileHeader__oTaXp","Button":"MobileHeader_Button__ogiwe","Title":"MobileHeader_Title__TuS2D"};